import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { nav } from "../content/site";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      data-testid="site-navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 1.4, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-cream/80 backdrop-blur-xl border-b border-brass/25" : "bg-transparent"
      }`}
    >
      <nav className="container-edge flex h-20 items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          onClick={(e) => go(e, "#top")}
          className="flex items-center gap-3"
          aria-label="Laundry Ventures home"
        >
          <span
            className={`font-serif text-lg tracking-tight transition-colors duration-500 ${
              scrolled ? "text-navy" : "text-cream"
            }`}
          >
            Laundry Ventures
          </span>
        </a>

        {/* Desktop */}
        <ul className="hidden items-center gap-9 lg:flex">
          {nav.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={(e) => go(e, item.href)}
                className={`link-underline font-sans text-sm transition-colors duration-500 ${
                  scrolled ? "text-navy/80 hover:text-navy" : "text-cream/80 hover:text-cream"
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        {/* Mobile toggle */}
        <button
          data-testid="nav-mobile-toggle"
          className={`lg:hidden ${scrolled ? "text-navy" : "text-cream"}`}
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Close menu" : "Open menu"}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-brass/25 bg-cream/95 backdrop-blur-xl lg:hidden"
          >
            <ul className="container-edge flex flex-col py-4">
              {nav.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    data-testid={`nav-mobile-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                    onClick={(e) => go(e, item.href)}
                    className="block py-3 font-serif text-2xl text-navy"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
